import React, { useEffect, useState } from 'react';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table } from 'reactstrap';
import classnames from "classnames";


import EstablishmentInfo from './Widgets/EstablishmentInfo';
import NormativeSection from './Sections/NormativeSection';
import ProductionSection from './Sections/ProductionSection';
import { icon } from 'leaflet';


const breadcrumbLinks = [
    { to: '#', label: 'Inicio', icon: 'icon-house' },
    { to: '#', label: 'Empresa', icon: 'icon-building-2' },
    { to: '#', label: 'Configuración', icon: 'icon-settings' },
];


const DashboardEstablishment = () => {

    const [activeTab, setactiveTab] = useState("1");
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    };


    // const [location, setLocation] = useState({
    //     loaded: false,
    //     coordinates: { lat: "", lng: "" },
    // });

    // const onSuccess = location => {
    //     setLocation({
    //         loaded: true,
    //         coordinates: {
    //             lat: location.coords.latitude,
    //             lng: location.coords.longitude,
    //         },
    //     });
    // };

    // const onError = error => {
    //     setLocation({
    //         loaded: true,
    //         error,
    //     });
    // };

    // useEffect(() => {
    //     if (!("geolocation" in navigator)) {
    //         onError({
    //             code: 0,
    //             message: "Geolocation not supported",
    //         });
    //     }

    //     navigator.geolocation.getCurrentPosition(onSuccess, onError);
    // }, []);




    const tileBoxes4 = [
        {
            id: 2,
            icon: "ri-play-circle-fill",
            iconClass: "warning",
            opacity: "bg-opacity-25",
            label: "En operación",
            labelClass: "muted",
            counter: "45",
            caption: "",
            captionClass: "muted",
            percentage: "10.35 %",
            percentageClass: "danger",
            badge: "ri-arrow-down-s-line",
            decimals: 0,
            separator: ",",
            suffix: "",
            prefix: "",
        },
        {
            id: 3,
            icon: "bx bxs-badge-dollar",
            iconClass: "danger",
            opacity: "bg-opacity-25",
            label: "Total Revenue",
            labelClass: "muted",
            counter: "2845.05",
            caption: "From $1,750.04 last year",
            captionClass: "muted",
            percentage: "22.96 %",
            percentageClass: "success",
            badge: "ri-arrow-up-s-line",
            decimals: 2,
            separator: ",",
            suffix: "",
            prefix: "$",
        },
        {
            id: 3,
            icon: "bx bxs-badge-dollar",
            iconClass: "danger",
            opacity: "bg-opacity-25",
            label: "Total Revenue",
            labelClass: "muted",
            counter: "2845.05",
            caption: "From $1,750.04 last year",
            captionClass: "muted",
            percentage: "22.96 %",
            percentageClass: "success",
            badge: "ri-arrow-up-s-line",
            decimals: 2,
            separator: ",",
            suffix: "",
            prefix: "$",
        },
    ];



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* <BreadCrumb title="Dashboard Establecimiento" links={breadcrumbLinks} /> */}

                    <Row className='layout-dashboard'>
                        <Col md={2}>
                            <EstablishmentInfo id={'662988cb349f7afd12930fa6'} />
                        </Col>

                        <Col md={10}>


                            <Row>
                                <Col xxl={12}>

                                    <Nav className="nav nav-pills arrow-navtabs nav-primary bg-light mb-3">
                                        <NavItem>
                                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "1", })} onClick={() => { toggle("1"); }} >
                                                Producción
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "2", })} onClick={() => { toggle("2"); }} >
                                                Operaciones
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "3", })} onClick={() => { toggle("3"); }} >
                                                Normativa
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "4", })} onClick={() => { toggle("4"); }} >
                                                Medio Ambiente
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "5", })} onClick={() => { toggle("5"); }} >
                                                Salud
                                            </NavLink>
                                        </NavItem>
                                    </Nav>

                                    <TabContent activeTab={activeTab} className="text-muted">
                                        <TabPane tabId="1" id="production">
                                            <ProductionSection/>
                                        </TabPane>

                                        <TabPane tabId="2" id="variable">
                                            <h6>Operacion</h6>
                                            <p className="mb-0">
                                                You've probably heard that opposites attract. The same is true for fonts. Don't be afraid to combine font styles that are different but complementary, like sans serif with serif, short with tall, or decorative with simple. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR.
                                            </p>
                                        </TabPane>

                                        <TabPane tabId="3" id="normative">
                                            <NormativeSection />
                                        </TabPane>

                                        <TabPane tabId="4" id="medio">
                                            <h6>Medio ambiente</h6>
                                            <p className="mb-0">
                                                You've probably heard that opposites attract. The same is true for fonts. Don't be afraid to combine font styles that are different but complementary, like sans serif with serif, short with tall, or decorative with simple. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR.
                                            </p>
                                        </TabPane>

                                        <TabPane tabId="5" id="logistic">
                                            <h6>Salud</h6>
                                            <p className="mb-0">
                                                You've probably heard that opposites attract. The same is true for fonts. Don't be afraid to combine font styles that are different but complementary, like sans serif with serif, short with tall, or decorative with simple. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR.
                                            </p>
                                        </TabPane>
                                    </TabContent>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>

            </div>
        </React.Fragment>
    );
};

export default DashboardEstablishment;